import React from 'react';
import s from './CreativityPage.module.css';
import Header from '../start-page/Header';
import Banner from './Banner';
import CtaSection from '../start-page/CtaSection';
import Footer from '../start-page/Footer';
import HeroSection from './HeroSection';
import DescribeSection from './DescribeSection';
import TextSection from './TextSection';
const CreativityPage: React.FC = () => {
    return (
        <div className={s.container}>
            <Header />
            <Banner />
            <HeroSection />
            <DescribeSection />
            <TextSection />
            <CtaSection />
            <Footer />
        </div>
    );
};

export default CreativityPage;
